import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import CompanySelect from './CompanySelect';

const CompanySelectController = ({ name, label = "Company", helptext, ...rest }) => {
    const { control, setValue, formState: { errors } } = useFormContext();

  return (
    <Controller
      name='company_number'
      control={control}
      defaultValue=""
      companyName = ''
      companyNumber = ''
      errors = ''
      validation = {null}
      align = 'left'
      sx ={{}}
      showRequiredIndicator = {false}
      label = 'Company'

      render={({ field }) => (
        <CompanySelect
          {...field}
          label
          errors
          control
          name
          align
          sx
          showRequiredIndicator
          helptext={helptext}
          onChange={(e) => {
            // Set both fields
            setValue("company_number", e.selectedvalue); // company_number
            setValue("company_name", e.text); // company_name
            setValue("registered_address", [e.registered_address])
          }}
        />
      )}
    />
  );
};

export default CompanySelectController;
